import { ADD_ASSESSMENT_OPTION, REMOVE_ASSESSMENT_OPTION } from "graphql/mutations";

const MUTATIONS = {
  addAssessmentOption: ADD_ASSESSMENT_OPTION,
  removeAssessmentOption: REMOVE_ASSESSMENT_OPTION
}

export default MUTATIONS;
